module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row contact-item list-item",
    class: {
      clickable: _vm.view_mode.anywhere_select, undraggable: !_vm.can_change_priority
    },
    on: {
      "click": function($event) {
        return _vm.anywhereSelectContact($event)
      }
    }
  }, [(_vm.view_mode.show_checkbox) ? _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    on: {
      "click": function($event) {
        return _vm.checkboxSelectContact($event)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected
    }
  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-120 contact-list-item-name overflow-hidden",
    class: {
      clickable: _vm.view_mode.name_go_to_show, "two-lines-col": _vm.view_mode.business == "below-name"
    },
    on: {
      "click": _vm.openContact
    }
  }, [_c('div', {
    staticClass: "contact-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.contact.full_name))]), (_vm.view_mode.business == "below-name") ? _c('div', {
    staticClass: "contact-business-inline overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.contact.business.name))]) : _vm._e()]), (_vm.view_mode.show_created_at_column) ? _c('div', {
    staticClass: "table-col table-col-50 contact-list-item-created-at text-gray-color"
  }, [_c('div', {
    staticClass: "contact-business"
  }, [_vm._v(_vm._s(_vm.contact.humalCreatedAt()))])]) : _vm._e(), (_vm.view_mode.business == "column") ? _c('div', {
    staticClass: "table-col overflow-hidden"
  }, [_c('div', {
    staticClass: "contact-business overflow-ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.contact.business.name))])]) : _vm._e(), (_vm.view_mode.flow) ? _c('div', {
    staticClass: "table-col overflow-hidden"
  }, [_c('div', {
    staticClass: "contact-flow-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.contact.flow.name))])]) : _vm._e(), (_vm.view_mode.action_step) ? _c('div', {
    staticClass: "table-col"
  }, [(_vm.contact.recipient && _vm.flow && _vm.contact.recipient.human_last_flow_action_taken) ? _c('div', {
    staticClass: "contact-recipient-action-step-info"
  }, [_c('div', {
    staticClass: "contact-recipient-last-action-step-taken"
  }, [_vm._v(_vm._s(_vm.contact.recipient.human_last_flow_action_taken))]), _vm._v("/"), _c('div', {
    staticClass: "contact-flow-number-of-actions"
  }, [_vm._v(_vm._s(_vm.flow.actions.length))]), (_vm.contactItemLastActionTakenStateIcon()) ? _c('span', {
    class: _vm.contactItemLastActionTakenStateIcon(),
    attrs: {
      "data-toggle": _vm.contact.recipient.lastActionTakenStateTooltipText() ? "tooltip" : null,
      "data-original-title": _vm.contact.recipient.lastActionTakenStateTooltipText(),
      "data-placement": "top"
    }
  }) : _vm._e(), (_vm.showEmailOpenStatisticBadge()) ? _c('span', {
    staticClass: "badge",
    attrs: {
      "data-toggle": "tooltip",
      "data-original-title": _vm.lastEmailOpenEventAt(),
      "data-placement": "top"
    }
  }, [_vm._v(_vm._s(_vm.contact.recipient.emailOpenStatistics().count) + "x")]) : _vm._e(), (_vm.contact.recipient.metadata.destroyed_tasks && _vm.contact.recipient.metadata.destroyed_tasks.length) ? _c('img', {
    staticClass: "skipped-actions",
    attrs: {
      "src": "/static/icons/skiped-actions.svg",
      "data-toggle": "tooltip",
      "data-original-title": _vm.skipped_actions_tooltip_text,
      "data-placement": "top"
    }
  }) : _vm._e()]) : _vm._e()]) : _vm._e(), (_vm.view_mode.show_status_updated_at_column) ? _c('div', {
    staticClass: "table-col contact-list-item-status-updated-at text-gray-color"
  }, [_vm._v(_vm._s(_vm.contact.humanStatusUpdatedAt()))]) : _vm._e(), (_vm.view_mode.show_stage_updated_at_column) ? _c('div', {
    staticClass: "table-col contact-list-item-stage-updated-at text-gray-color"
  }, [_vm._v(_vm._s(_vm.contact.humanStageUpdatedAt()))]) : _vm._e(), (_vm.view_mode.status) ? _c('div', {
    staticClass: "table-col contact-list-item-status"
  }, [_c('div', {
    staticClass: "dropdown hover-margin-status"
  }, [_c('a', {
    staticClass: "margin-status",
    class: _vm.contactItemStatusClasses(),
    attrs: {
      "type": "button",
      "data-toggle": _vm.contactStatusDropdownAvailable()
    }
  }, [_c('span', {
    class: _vm.contactStatusIconClass()
  }), _c('div', {
    staticClass: "contact-status"
  }, [_vm._v(_vm._s(_vm.contact.human_recipient_status))])]), (_vm.canUpdateContact()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.contact.next_valid_recipient_statuses), function(next_status_options, next_status) {
    return _c('li', [_c('a', {
      class: {
        "show-connected-options": next_status == "connected"
      },
      on: {
        "click": function($event) {
          return _vm.updateContactRecipient($event, {
            status: next_status
          })
        }
      }
    }, [_vm._v(_vm._s(next_status_options.human_action_name)), _c('ul', {
      staticClass: "dropdown-menu connected-options",
      staticStyle: {
        "display": "none"
      }
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndSendToNewFlow($event)
        }
      }
    }, [_vm._v("Enviar para fluxo")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndCreateTask($event)
        }
      }
    }, [_vm._v("Criar tarefa")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndChangeStage($event)
        }
      }
    }, [_vm._v("Alterar estágio")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndLost($event)
        }
      }
    }, [_vm._v("Perdido")])])])])])
  }), (_vm.contact.recipient_status == 'converting') ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openRecipientScheduleReactivationModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()], 2) : _vm._e()])]) : _vm._e(), (_vm.view_mode.stage) ? _c('div', {
    staticClass: "table-col contact-list-item-stage"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [(_vm.show_flow_search) ? _c('autocomplete', {
    attrs: {
      "contact": _vm.contact
    },
    on: {
      "hide": _vm.hideFlowSearch,
      "flow-selected": _vm.updateContactInfo
    }
  }) : _vm._e(), _c('a', {
    class: _vm.contactItemStageClasses(),
    attrs: {
      "type": "button",
      "data-toggle": _vm.view_mode.allow_update_stage && _vm.contactStageDropdownAvailable()
    }
  }, [_c('div', {
    staticClass: "contact-stage"
  }, [_vm._v(_vm._s(_vm.contact.human_stage))])]), (_vm.canUpdateContact()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.contact.next_valid_stages), function(next_stage_options, next_stage) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.setLostInfo($event, {
            stage: next_stage
          })
        }
      }
    }, [_vm._v(_vm._s(next_stage_options.human_name))])])
  }), 0) : _vm._e()], 1)]) : _vm._e(), (_vm.view_mode.group) ? _c('div', {
    staticClass: "table-col overflow-hidden"
  }, [_c('div', {
    staticClass: "contact-group-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.contact.contact_group ? _vm.contact.contact_group.name : ''))])]) : _vm._e(), (_vm.view_mode.user && !_vm.view_mode.only_picture_miniature) ? _c('div', {
    staticClass: "table-col contact-list-item-user"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.contact.user,
      "options": {
        first_name: true
      }
    }
  })], 1) : _vm._e(), (_vm.view_mode.user && _vm.view_mode.only_picture_miniature) ? _c('div', {
    staticClass: "table-col table-col-30"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.contact.user,
      "options": {
        first_name: true,
        only_picture: true
      }
    }
  })], 1) : _vm._e(), (_vm.view_mode.initialized_contact_icon) ? _c('div', {
    staticClass: "table-col table-col-collapsed show"
  }, [(!_vm.can_change_priority) ? _c('span', {
    staticClass: "glyphicon glyphicon-ok-circle reev-base-green-color single-line-tooltip",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "data-original-title": _vm.$t('contacts.tooltip.text.startedInFlow')
    }
  }) : _vm._e()]) : _vm._e(), _vm._t("default"), (_vm.view_mode.actions_dropdown) ? _c('div', {
    staticClass: "table-col table-col-collapsed",
    on: {
      "!click": function($event) {}
    }
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu multi-level"
  }, [(_vm.show_send_to_flow && _vm.canUpdateContact()) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.show_flow_search = true
      }
    }
  }, [_vm._v("Enviar para fluxo")])]) : _vm._e(), (_vm.contact.id) ? _c('li', [_c('a', {
    on: {
      "click": _vm.viewContact
    }
  }, [_vm._v("Visualizar")])]) : _vm._e(), (_vm.canUpdateContact()) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.destroyContact($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.remove_label))])]) : _vm._e(), (_vm.show_reset_contact && _vm.canUpdateContact()) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.resetContactRecipient($event)
      }
    }
  }, [_vm._v("Resetar")])]) : _vm._e(), (_vm.canScheduleReactivation() && _vm.canUpdateContact()) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openRecipientScheduleReactivationModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()])])])]) : (_vm.view_mode.anywhere_select_action == 'emit-selected') ? _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_vm._m(1)]) : _vm._e(), (_vm.view_mode.number_of_tags > 0) ? _c('div', {
    staticClass: "tags-list",
    style: ({
      left: _vm.tags_margin_left
    })
  }, [_vm._l((_vm.contact.tags), function(tag, index) {
    return (index < _vm.view_mode.number_of_tags) ? _c('tag', {
      style: ({
        color: '#' + tag.color
      }),
      attrs: {
        "tag": tag
      }
    }, [_vm._v(_vm._s(tag.name))]) : _vm._e()
  }), (_vm.overflow_tags) ? _c('div', {
    staticClass: "tags_number",
    on: {
      "click": _vm.viewContact
    }
  }, [_vm._v(_vm._s(_vm.overflow_tags_count) + "+")]) : _vm._e()], 2) : _vm._e(), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
    attrs: {
      "contact": _vm.contact,
      "temp_attr": _vm.temp_attr
    },
    on: {
      "close-lost-reason-modal": function($event) {
        return _vm.closeLostReasonModal()
      },
      "update-contact-recipient": _vm.updateLostContact
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('button', {
    staticClass: "btn select-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e8e69e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/list_item.vue
// module id = 1108
// module chunks = 1